export default __webpack_public_path__ + "static/media/Sarah2@2x.f12138b3.jpg";